import type { TMessages } from '@/types/TMessages'

export const messages = {
  grade: 'Оцените от 1 до 5',
} as const satisfies TMessages
